import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "pt-5" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = {
  key: 0,
  class: "column is-paddingless is-9"
}
const _hoisted_5 = { class: "column is-paddingless" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Events = _resolveComponent("Events")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.showIframe)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("iframe", {
                id: "infigo-product-editor",
                width: "100%",
                height: "800px",
                scrolling: "no",
                frameborder: "0",
                class: "infigo-main-editor is-clipped",
                src: _ctx.iframeEditorSrc
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Events, {
            events: _ctx.events,
            onClear: _ctx.clearEvents
          }, null, 8, ["events", "onClear"])
        ])
      ])
    ])
  ]))
}